import type { RpcErrorCode } from './types';

/** RPC が RAISE EXCEPTION で返したエラー。code はサーバーの文字列そのまま */
export class RpcError extends Error {
  constructor(
    readonly code: RpcErrorCode | 'network' | 'unknown',
    message?: string,
  ) {
    super(message ?? code);
    this.name = 'RpcError';
  }
  /** 通信できなかった（圏外・タイムアウト）。再送してよい */
  get isNetwork(): boolean {
    return this.code === 'network';
  }
}

/** PostgREST のエラー本文から RAISE の文字列を取り出す */
export function toRpcError(e: unknown): RpcError {
  if (e instanceof RpcError) return e;
  if (e && typeof e === 'object') {
    const o = e as { message?: unknown; code?: unknown; name?: unknown };
    const msg = typeof o.message === 'string' ? o.message : '';
    if (o.name === 'TypeError' || /Failed to fetch|NetworkError|Load failed|network/i.test(msg)) {
      return new RpcError('network', msg);
    }
    if (o.code === 'P0001' && /^[a-z_]+$/.test(msg)) return new RpcError(msg as RpcErrorCode, msg);
    if (/^[a-z_]+$/.test(msg)) return new RpcError(msg as RpcErrorCode, msg);
    return new RpcError('unknown', msg || String(o.code ?? ''));
  }
  return new RpcError('unknown', String(e));
}
